/* Chelín PRO — vanilla JS, no dependencies. Favorites, card carousel + quick add,
   cart drawer refresh (Dawn Section Rendering), discount code, product page,
   size table + finder, recently viewed, collection view + infinite scroll, home tabs, FAQ. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(k) { try { return JSON.parse(localStorage.getItem(k)) || []; } catch (e) { return []; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } },
    raw(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  };

  /* ---------- Favorites ---------- */
  const FAV = 'chelin:favs';
  function syncFavs() {
    const favs = store.get(FAV);
    $$('[data-fav]').forEach((b) => b.setAttribute('aria-pressed', favs.includes(b.dataset.fav) ? 'true' : 'false'));
    $$('[data-fav-count]').forEach((c) => { c.textContent = favs.length; c.hidden = favs.length === 0; });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault();
    const favs = store.get(FAV);
    const h = b.dataset.fav;
    const i = favs.indexOf(h);
    if (i > -1) favs.splice(i, 1); else favs.unshift(h);
    store.set(FAV, favs.slice(0, 60));
    syncFavs();
  });

  /* ---------- Cart ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() {
    const d = drawer();
    return d && d.getSectionsToRender ? d.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];
  }
  async function addToCart(id, qty = 1) {
    const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }], sections: sectionIds(), sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'No pudimos agregar esta prenda. Intenta de nuevo o escríbenos por WhatsApp.');
    const d = drawer();
    if (d && data.sections) {
      d.classList.remove('is-empty');
      d.renderContents(data);
    } else {
      window.location.href = '/cart';
    }
    document.dispatchEvent(new CustomEvent('chelin:cart-added', { detail: data }));
    return data;
  }
  window.ChelinCart = { add: addToCart };

  document.addEventListener('click', async (e) => {
    const open = e.target.closest('[data-cp-open]');
    if (open) {
      e.preventDefault();
      const card = open.closest('[data-cp]');
      const isOpen = card.classList.toggle('is-qa-open');
      open.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }
    const add = e.target.closest('[data-cp-add]');
    if (!add || add.disabled || add.tagName === 'A') return;
    e.preventDefault();
    const label = add.innerHTML;
    add.disabled = true;
    add.classList.add('is-loading');
    try {
      await addToCart(add.dataset.cpAdd);
      add.innerHTML = '✓';
      const card = add.closest('[data-cp]');
      if (card) setTimeout(() => card.classList.remove('is-qa-open'), 900);
    } catch (err) {
      add.innerHTML = 'Sin stock';
    } finally {
      add.classList.remove('is-loading');
      setTimeout(() => { add.innerHTML = label; add.disabled = false; }, 1400);
    }
  });

  /* Discount code inside the drawer (Cart AJAX API «discount»). */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-chelin-discount]');
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('input');
    const msg = form.querySelector('.chelin-discount__msg');
    const code = input.value.trim();
    if (!code) return;
    msg.textContent = 'Aplicando…';
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code, sections: sectionIds(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      const found = (data.discount_codes || []).find((c) => c.code.toLowerCase() === code.toLowerCase());
      const d = drawer();
      if (d && data.sections) d.renderContents(data);
      const newMsg = $('.chelin-discount__msg');
      if (newMsg) newMsg.textContent = found && found.applicable ? `Código ${found.code} aplicado.` : 'Este código no es válido para tu carrito.';
    } catch (err) {
      msg.textContent = 'No pudimos aplicar el código. Intenta de nuevo.';
    }
  });

  /* ---------- Card photo carousel ---------- */
  function cardIndex(track) {
    return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
  }
  function updateCard(track) {
    const card = track.closest('[data-cp]');
    if (!card) return;
    const i = cardIndex(track);
    const n = track.children.length;
    $$('.cp__progress span', card).forEach((s, k) => s.classList.toggle('is-active', k === i));
    const prev = $('[data-cp-prev]', card);
    const next = $('[data-cp-next]', card);
    if (prev) prev.hidden = i <= 0;
    if (next) next.hidden = i >= n - 1;
  }
  document.addEventListener('scroll', (e) => {
    const t = e.target;
    if (t && t.matches && t.matches('[data-cp-track]')) window.requestAnimationFrame(() => updateCard(t));
  }, { capture: true, passive: true });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cp-prev], [data-cp-next]');
    if (!b) return;
    e.preventDefault();
    const track = $('[data-cp-track]', b.closest('[data-cp]'));
    const dir = b.hasAttribute('data-cp-next') ? 1 : -1;
    track.scrollTo({ left: (cardIndex(track) + dir) * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---------- Accordions: one open at a time ---------- */
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    const group = d.closest('[data-pp-acc], [data-faq]');
    if (!group) return;
    $$('details', group).forEach((o) => { if (o !== d && o.closest('[data-pp-acc], [data-faq]') === group) o.open = false; });
  }, true);

  /* ---------- Product page ---------- */
  function initProduct(root) {
    const low = Number(root.dataset.low || 3);
    const wa = root.dataset.wa;
    const needsSize = root.dataset.needsSize === 'true';
    const form = $('[data-pp-form]', root);
    const input = $('[data-pp-variant]', root);
    const addBtn = $('[data-pp-add]', root);
    const buyBtn = $('[data-pp-buy]', root);
    const notify = $('[data-pp-notify]', root);
    const err = $('[data-pp-error]', root);
    const sizeErr = $('[data-pp-size-error]', root);
    const sizes = $('[data-pp-sizes]', root);
    const stock = $('[data-pp-stock]', root);
    const title = $('.pp__title', root) ? $('.pp__title', root).textContent.trim() : '';

    /* recently viewed */
    const recent = store.get('chelin:recent').filter((h) => h !== root.dataset.handle);
    recent.unshift(root.dataset.handle);
    store.set('chelin:recent', recent.slice(0, 20));

    /* gallery */
    const track = $('[data-pp-track]', root);
    if (track) {
      const slides = $$('[data-pp-slide]', track);
      const cur = $('[data-pp-current]', root);
      const prev = $('[data-pp-prev]', root);
      const next = $('[data-pp-next]', root);
      const thumbs = $$('[data-pp-thumb]', root);
      const idx = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      const go = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      const sync = () => {
        const i = idx();
        if (cur) cur.textContent = i + 1;
        if (prev) prev.hidden = i <= 0;
        if (next) next.hidden = i >= slides.length - 1;
        thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      };
      track.addEventListener('scroll', () => window.requestAnimationFrame(sync), { passive: true });
      prev && prev.addEventListener('click', () => go(idx() - 1));
      next && next.addEventListener('click', () => go(idx() + 1));
      thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.ppThumb))));
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') go(idx() + 1);
        if (e.key === 'ArrowLeft') go(idx() - 1);
      });
    }

    let selected = null;
    const label = $('[data-pp-size-label]', root);
    const price = $('[data-pp-price] .pp__now', root);
    const stickyPrice = $('[data-pp-sticky-price]', root);
    const stickyBtn = $('[data-pp-sticky-btn]', root);

    function select(btn) {
      $$('[data-pp-size]', root).forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
      selected = btn;
      input.value = btn.dataset.ppSize;
      if (label) label.textContent = btn.dataset.title;
      if (price && btn.dataset.price) price.textContent = btn.dataset.price;
      if (stickyPrice && btn.dataset.price) stickyPrice.textContent = btn.dataset.price;
      if (sizes) sizes.classList.remove('is-error');
      if (sizeErr) sizeErr.hidden = true;
      if (err) err.hidden = true;
      const available = btn.dataset.available === 'true';
      const qty = btn.dataset.qty !== undefined ? Number(btn.dataset.qty) : null;
      if (stock) {
        const showLow = available && qty !== null && qty > 0 && qty <= low;
        stock.hidden = !showLow;
        if (showLow) $('[data-pp-stock-text]', stock).textContent = qty === 1 ? 'Queda 1 en esta talla' : `Quedan ${qty} en esta talla`;
      }
      if (available) {
        addBtn.disabled = false;
        addBtn.textContent = 'Añadir al carrito';
        if (buyBtn) buyBtn.hidden = false;
        if (notify) notify.hidden = true;
        if (stickyBtn) stickyBtn.textContent = 'Añadir';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Agotado';
        if (buyBtn) buyBtn.hidden = true;
        if (notify) {
          const text = `Hola Chelín, me interesa ${title} en talla ${btn.dataset.title}, que aparece agotada. ¿Me cuentan si la tendrán de nuevo? ${window.location.origin}${window.location.pathname}`;
          notify.href = `https://wa.me/${wa}?text=${encodeURIComponent(text)}`;
          notify.hidden = false;
        }
        if (stickyBtn) stickyBtn.textContent = 'Agotado';
      }
    }
    $$('[data-pp-size]', root).forEach((b) => b.addEventListener('click', () => select(b)));

    function requireSize() {
      if (!needsSize || input.value) return true;
      if (sizes) {
        sizes.classList.add('is-error');
        sizes.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
      if (sizeErr) sizeErr.hidden = false;
      return false;
    }
    async function submit(goCheckout) {
      if (!requireSize()) return;
      if (selected && selected.dataset.available !== 'true') return;
      const btn = goCheckout ? buyBtn : addBtn;
      btn.classList.add('is-loading');
      btn.disabled = true;
      try {
        await addToCart(input.value);
        if (goCheckout) window.location.href = '/checkout';
      } catch (e2) {
        if (err) { err.textContent = e2.message; err.hidden = false; }
      } finally {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }
    }
    form && form.addEventListener('submit', (e) => { e.preventDefault(); submit(false); });
    buyBtn && buyBtn.addEventListener('click', () => submit(true));
    stickyBtn && stickyBtn.addEventListener('click', () => {
      if (!requireSize()) return;
      if (selected && selected.dataset.available !== 'true') return;
      submit(false);
    });

    /* sticky bar while the buy buttons are off screen */
    const sticky = $('[data-pp-sticky]', root);
    const buttons = $('[data-pp-buttons]', root);
    if (sticky && buttons && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn && (stickyBtn.tabIndex = show ? 0 : -1);
      }).observe(buttons);
    }

    /* rotating trust band */
    const trust = $$('[data-pp-trust] li', root);
    if (trust.length > 1 && !reduce) {
      let t = 0;
      trust[0].classList.add('is-active');
      setInterval(() => { trust[t].classList.remove('is-active'); t = (t + 1) % trust.length; trust[t].classList.add('is-active'); }, 3500);
    } else if (trust.length) {
      trust.forEach((li) => li.classList.add('is-active'));
    }

    initFit(root, select, sizes);
  }

  /* ---------- Size calculator «Probador» (snippet chelin-fit) ----------
     Measurements are of the garment laid flat. For each measure we take the smallest size whose
     value reaches it; the overall size is the largest of those, so «between two sizes» always
     resolves to the bigger one. Up to 1 cm over the biggest size still counts as that size. */
  function initFit(root, select, sizesBox) {
    const dlg = $('[data-fit]', root);
    if (!dlg) return;
    const sizes = dlg.dataset.sizes.split('|');
    const key = `chelin:fit:${dlg.dataset.fitType}`;
    const fmt = (n) => String(n).replace('.', ',');
    const digits = (s) => (String(s).match(/\d+/g) || []).join('-');
    const dims = $$('[data-fit-dim]', dlg).map((el) => {
      const values = el.dataset.values.split(',').map((v) => parseFloat(v.replace(',', '.')));
      const input = $('input', el);
      input.min = Math.floor(Math.min(...values) - 8);
      input.max = Math.ceil(Math.max(...values) + 8);
      input.value = values[Math.floor((values.length - 1) / 2)];
      return { el, label: el.dataset.label, values, input, out: $('[data-fit-out]', el) };
    });
    if (!dims.length) return;
    let saved = null;
    try { saved = JSON.parse(store.raw(key)); } catch (e) { saved = null; }
    if (saved) dims.forEach((d) => { if (saved[d.label] !== undefined) d.input.value = saved[d.label]; });

    function compute() {
      let idx = 0;
      let between = false;
      let over = false;
      let under = true;
      dims.forEach((d) => {
        const m = Number(d.input.value);
        const v = d.values;
        const last = v[v.length - 1];
        let i = v.findIndex((x) => x >= m - 0.25);
        if (i < 0) i = v.length - 1;
        if (m > last + 1) over = true;
        if (m >= v[0] - 1) under = false;
        const exact = v.some((x) => Math.abs(x - m) <= 0.25);
        if (!exact && m > v[0] && m < last) between = true;
        d.idx = i;
        idx = Math.max(idx, i);
      });
      if (new Set(dims.map((d) => d.idx)).size > 1) between = true;
      return { idx, size: sizes[idx], between, over, under };
    }
    const sizeBtn = (size) => $$('[data-pp-size]', root).find((b) => digits(b.dataset.title) === digits(size));

    function paint() {
      dims.forEach((d) => { d.out.textContent = fmt(d.input.value); });
      $('[data-fit-estimate]', dlg).textContent = compute().size;
    }
    function mark(r) {
      $$('[data-fit-col]', root).forEach((c) => c.classList.toggle('is-fit', Number(c.dataset.fitCol) === r.idx));
      $$('[data-pp-size]', root).forEach((b) => b.classList.remove('is-fit'));
      const b = sizeBtn(r.size);
      if (b) b.classList.add('is-fit');
      $$('[data-fit-link-text]', root).forEach((t) => { t.textContent = `Su talla: ${r.size}`; });
    }
    function showResult() {
      const r = compute();
      $('[data-fit-size]', dlg).textContent = r.size;
      let msg = `Sus medidas coinciden con la talla ${r.size}.`;
      if (r.over) msg = `Sus medidas superan nuestra talla más grande. La ${r.size} es la más amplia que tenemos y puede quedarle más ajustada que la prenda que mediste.`;
      else if (r.under) msg = `La ${r.size} es nuestra talla más pequeña: le quedará más amplia que la prenda que mediste.`;
      else if (r.between) msg = `Está entre dos tallas. Te sugerimos la ${r.size}, la más grande, para más comodidad.`;
      const msgEl = $('[data-fit-msg]', dlg);
      msgEl.textContent = msg;
      msgEl.classList.toggle('is-warn', r.over || r.between);
      $$('[data-fit-row]', dlg).forEach((row) => row.classList.toggle('is-fit', Number(row.dataset.fitRow) === r.idx));
      const use = $('[data-fit-use]', dlg);
      const b = sizeBtn(r.size);
      use.disabled = !b;
      if (!b) use.textContent = `La talla ${r.size} no está disponible en esta prenda`;
      else if (b.dataset.available !== 'true') use.textContent = `Talla ${r.size} agotada en esta prenda`;
      else use.textContent = `Usar talla ${r.size}`;
      use.onclick = () => {
        if (b) select(b);
        dlg.close();
        if (sizesBox) sizesBox.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      };
      $('[data-fit-panel="1"]', dlg).hidden = true;
      $('[data-fit-panel="2"]', dlg).hidden = false;
      const remember = $('[data-fit-remember]', dlg);
      if (remember.checked) {
        const data = {};
        dims.forEach((d) => { data[d.label] = Number(d.input.value); });
        store.raw(key, JSON.stringify(data));
        mark(r);
      }
    }
    function open() {
      $('[data-fit-panel="1"]', dlg).hidden = false;
      $('[data-fit-panel="2"]', dlg).hidden = true;
      paint();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    }

    dims.forEach((d) => d.input.addEventListener('input', paint));
    $$('[data-fit-pm]', dlg).forEach((b) => b.addEventListener('click', () => {
      const d = dims.find((x) => x.el.contains(b));
      const n = Math.min(Number(d.input.max), Math.max(Number(d.input.min), Number(d.input.value) + Number(b.dataset.fitPm)));
      d.input.value = n;
      paint();
    }));
    $('[data-fit-next]', dlg).addEventListener('click', showResult);
    $('[data-fit-back]', dlg).addEventListener('click', () => {
      $('[data-fit-panel="1"]', dlg).hidden = false;
      $('[data-fit-panel="2"]', dlg).hidden = true;
    });
    $('[data-fit-close]', dlg).addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => {
      if (e.target !== dlg) return;
      const r = dlg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
    });
    $$('[data-fit-open]', root).forEach((b) => b.addEventListener('click', open));
    paint();
    if (saved) mark(compute());
  }

  /* ---------- Favorites / recently viewed lists ---------- */
  async function initList(root) {
    const src = root.dataset.plist === 'favs' ? FAV : 'chelin:recent';
    const limit = Number(root.dataset.limit || 8);
    const handles = store.get(src).filter((h) => h && h !== root.dataset.exclude).slice(0, limit);
    const grid = $('[data-plist-grid]', root);
    const empty = $('[data-plist-empty]', root);
    if (!handles.length) {
      if (empty) empty.hidden = false; else root.hidden = true;
      return;
    }
    const cards = await Promise.all(handles.map((h) => fetch(`/products/${encodeURIComponent(h)}?section_id=card-render`).then((r) => (r.ok ? r.text() : '')).catch(() => '')));
    cards.forEach((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const card = doc.querySelector('[data-cp]');
      if (!card) return;
      const li = document.createElement('li');
      li.appendChild(card);
      grid.appendChild(li);
    });
    if (!grid.children.length) { if (empty) empty.hidden = false; else root.hidden = true; }
    syncFavs();
  }

  /* ---------- Collection: view toggle + infinite scroll ---------- */
  function applyView() {
    const grid = $('#product-grid');
    if (!grid) return;
    const m = store.raw('chelin:view-m') || '2';
    const d = store.raw('chelin:view-d') || '4';
    grid.dataset.viewM = m;
    grid.dataset.viewD = d;
    $$('[data-view]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.view === m || b.dataset.view === d ? 'true' : 'false'));
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-view]');
    if (!b) return;
    const v = b.dataset.view;
    store.raw(Number(v) <= 2 ? 'chelin:view-m' : 'chelin:view-d', v);
    applyView();
  });
  let pagerObserver;
  function initPager() {
    const next = $('[data-pager-next]');
    if (pagerObserver) pagerObserver.disconnect();
    if (!next || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('chelin-infinite');
    let loading = false;
    pagerObserver = new IntersectionObserver(async ([entry]) => {
      if (!entry.isIntersecting || loading) return;
      loading = true;
      next.classList.add('is-loading');
      try {
        const html = await fetch(next.href).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = $('#product-grid');
        $$('#product-grid > li', doc).forEach((li) => grid.appendChild(li));
        const pager = $('[data-pager]');
        const newPager = $('[data-pager]', doc);
        if (pager) { if (newPager) pager.replaceWith(newPager); else pager.remove(); }
        syncFavs();
        initPager();
      } catch (err) {
        next.classList.remove('is-loading');
        loading = false;
      }
    }, { rootMargin: '600px 0px' });
    pagerObserver.observe(next);
  }
  function initCollection() {
    const container = $('#ProductGridContainer');
    if (!container) return;
    applyView();
    initPager();
    new MutationObserver(() => { applyView(); initPager(); syncFavs(); }).observe(container, { childList: true });
  }

  /* ---------- Home tabs ---------- */
  function initTabs(root) {
    const tabs = $$('[role=tab]', root);
    const list = $('[data-tab-products]', root);
    const panel = $('[data-tab-panel]', root);
    const all = $('[data-tab-all]', root);
    const allTitle = $('[data-tab-all-title]', root);
    const cache = {};
    cache[tabs[0] && tabs[0].dataset.tabUrl] = list.innerHTML;
    tabs.forEach((tab) => tab.addEventListener('click', async () => {
      tabs.forEach((t) => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
      panel.setAttribute('aria-labelledby', tab.id);
      const url = tab.dataset.tabUrl;
      all.href = url;
      allTitle.textContent = tab.dataset.tabTitle;
      if (!cache[url]) {
        list.classList.add('is-loading');
        try {
          const html = await fetch(`${url}?section_id=chelin-tab-panel`).then((r) => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const ul = doc.querySelector('[data-tab-products]');
          cache[url] = ul ? ul.innerHTML : '';
        } catch (e) { cache[url] = list.innerHTML; }
        list.classList.remove('is-loading');
      }
      list.innerHTML = cache[url];
      list.scrollLeft = 0;
      syncFavs();
      window.dispatchEvent(new Event('resize'));
    }));
    root.addEventListener('keydown', (e) => {
      const i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      if (e.key === 'ArrowRight') tabs[(i + 1) % tabs.length].focus();
      if (e.key === 'ArrowLeft') tabs[(i - 1 + tabs.length) % tabs.length].focus();
    });
  }

  /* ---------- Home categories: looping swipe carousel on mobile ----------
     Clones the tiles before and after the originals and silently jumps back to the middle set
     when the visitor reaches either end, so swiping never stops. Neighbours shrink and tuck
     under the centred card; the button names the next category. */
  function initCats(root) {
    const track = $('[data-cat-track]', root);
    if (!track || track.dataset.catReady) return;
    track.dataset.catReady = '1';
    const originals = $$('[data-cat-item]', track);
    const n = originals.length;
    if (n < 2) return;
    const mq = window.matchMedia('(max-width: 749px)');
    const dots = $$('.chelin-cats-nav__dots span', root);
    const nextBtn = $('[data-cat-next]', root);
    const nextLabel = $('[data-cat-next-label]', root);
    const titles = originals.map((li) => ($('.chelin-tile__title', li) || li).textContent.trim());
    let active = false;
    let settleTimer;
    let nudged = false;

    const items = () => $$('[data-cat-item]', track);
    const clone = (li) => {
      const c = li.cloneNode(true);
      c.setAttribute('data-cat-clone', '');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-shopify-editor-block');
      $$('a, button', c).forEach((a) => { a.tabIndex = -1; });
      return c;
    };
    const centerOf = (el) => el.offsetLeft + el.offsetWidth / 2;
    const go = (i, smooth) => {
      const el = items()[i];
      if (el) track.scrollTo({ left: centerOf(el) - track.clientWidth / 2, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    };
    const nearest = () => {
      const mid = track.scrollLeft + track.clientWidth / 2;
      let best = 0;
      let dist = Infinity;
      items().forEach((el, i) => { const d = Math.abs(centerOf(el) - mid); if (d < dist) { dist = d; best = i; } });
      return best;
    };
    function paint() {
      if (!active) return;
      const all = items();
      const step = all[1].offsetLeft - all[0].offsetLeft || 1;
      const mid = track.scrollLeft + track.clientWidth / 2;
      all.forEach((el) => {
        const d = (centerOf(el) - mid) / step;
        const a = Math.min(Math.abs(d), 1.5);
        el.style.transform = reduce ? '' : `translateX(${-Math.sign(d) * Math.min(a, 1) * step * 0.05}px) scale(${1 - 0.1 * Math.min(a, 1)})`;
        el.style.zIndex = String(10 - Math.round(a * 4));
      });
      const real = ((nearest() - n) % n + n) % n;
      dots.forEach((s, i) => s.classList.toggle('is-active', i === real));
      if (nextLabel) nextLabel.textContent = `Siguiente: ${titles[(real + 1) % n]}`;
    }
    function settle() {
      const i = nearest();
      if (i < n) go(i + n, false);
      else if (i >= 2 * n) go(i - n, false);
    }
    function enable() {
      if (active) return;
      track.prepend(...originals.map(clone));
      track.append(...originals.map(clone));
      active = true;
      go(n, false);
      paint();
    }
    function disable() {
      if (!active) return;
      $$('[data-cat-clone]', track).forEach((c) => c.remove());
      originals.forEach((el) => { el.style.transform = ''; el.style.zIndex = ''; });
      active = false;
    }
    const sync = () => (mq.matches ? enable() : disable());
    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(paint);
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 140);
    }, { passive: true });
    if (nextBtn) nextBtn.addEventListener('click', () => { if (active) go(nearest() + 1, true); });
    if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
    window.addEventListener('resize', () => { if (active) { go(nearest(), false); paint(); } });
    sync();
    /* one gentle nudge the first time the carousel scrolls into view, so it reads as swipeable */
    if ('IntersectionObserver' in window && !reduce) {
      const io = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting || nudged || !active) return;
        nudged = true;
        io.disconnect();
        setTimeout(() => {
          track.scrollBy({ left: 70, behavior: 'smooth' });
          setTimeout(() => go(n, true), 650);
        }, 400);
      }, { threshold: 0.6 });
      io.observe(track);
    }
  }

  function init() {
    syncFavs();
    $$('[data-pp]').forEach(initProduct);
    $$('[data-plist]').forEach(initList);
    $$('[data-tabs]').forEach(initTabs);
    $$('[data-cat-carousel]').forEach(initCats);
    initCollection();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
